import { render, staticRenderFns } from "./ContratoGrillaArchivo.vue?vue&type=template&id=61889ef5&"
import script from "./ContratoGrillaArchivo.vue?vue&type=script&lang=ts&"
export * from "./ContratoGrillaArchivo.vue?vue&type=script&lang=ts&"
import style0 from "./ContratoGrillaArchivo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('61889ef5', component.options)
    } else {
      api.reload('61889ef5', component.options)
    }
    module.hot.accept("./ContratoGrillaArchivo.vue?vue&type=template&id=61889ef5&", function () {
      api.rerender('61889ef5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/Contratos/ContratoGrillaArchivo.vue"
export default component.exports